export function getLocalDateInt(now: Date = new Date()): number {
    return now.getFullYear() * 10000
        + (now.getMonth() + 1) * 100
        + now.getDate();
}

export function determineTaxBilled(isHstDisbursement: boolean, otherTaxType?: string): string {
    if (!isHstDisbursement) {
        return 'Exempt';
    }

    if (otherTaxType === 'GST') {
        return 'Federal';
    }

    if (otherTaxType === 'PST') {
        return 'State';
    }

    if (otherTaxType === 'Both') {
        return 'FederalAndState';
    }

    if (otherTaxType === 'None') {
        return 'Exempt';
    }

    return 'Federal';
}

const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

export function resolveTaskId(defaultTaskId: string | null, tasks: any[]): string | null {
    if (defaultTaskId && defaultTaskId !== EMPTY_GUID) {
        return defaultTaskId;
    }

    // "bw" = "Billable Work" — Soluno's default general-purpose task code name
    const bwTask = tasks.find((t: any) => t.Name === 'bw');
    if (bwTask) {
        return bwTask.Id;
    }

    return null;
}
